const KoruWatermark = () => {
  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
      {/* Top Right Koru - Large spiral */}
      <svg
        className="absolute -top-5 -right-5 w-72 h-72 opacity-[0.08]"
        viewBox="0 0 200 200"
        fill="none"
      >
        <path
          d="M 100 20 
             Q 160 20 170 80 
             Q 180 140 120 150 
             Q 60 160 50 100 
             Q 40 40 100 30
             Q 140 25 150 70
             Q 160 115 110 125
             Q 60 135 55 90
             Q 50 45 100 40
             Q 130 38 140 75
             Q 150 112 105 118
             Q 60 124 58 85
             Q 56 46 100 50"
          stroke="#14b8a6"
          strokeWidth="5"
          strokeLinecap="round"
          fill="none"
        />
      </svg>

      {/* Bottom Left Large Koru */}
      <svg
        className="absolute -bottom-16 -left-16 w-[400px] h-[400px] opacity-[0.07]"
        viewBox="0 0 200 200"
        fill="none"
      >
        <path
          d="M 100 180 
             Q 40 180 30 120 
             Q 20 60 80 50 
             Q 140 40 150 100 
             Q 160 160 100 170
             Q 60 175 50 130
             Q 40 85 90 75
             Q 140 65 145 110
             Q 150 155 100 160
             Q 70 162 60 125
             Q 50 88 95 82
             Q 140 76 142 115
             Q 144 154 100 155"
          stroke="#14b8a6"
          strokeWidth="5"
          strokeLinecap="round"
          fill="none"
        />
      </svg>

      {/* Middle Right Koru */}
      <svg
        className="absolute top-1/2 -right-8 w-48 h-48 opacity-[0.06] transform -translate-y-1/2"
        viewBox="0 0 200 200"
        fill="none"
      >
        <path
          d="M 100 20 
             Q 160 20 170 80 
             Q 180 140 120 150 
             Q 60 160 50 100 
             Q 40 40 100 30
             Q 140 25 150 70
             Q 160 115 110 125
             Q 60 135 55 90"
          stroke="#22c55e"
          strokeWidth="4"
          strokeLinecap="round"
          fill="none"
        />
      </svg>

      {/* Top Left Koru */}
      <svg
        className="absolute top-72 -left-4 w-36 h-36 opacity-[0.06]"
        viewBox="0 0 200 200"
        fill="none"
      >
        <path
          d="M 100 180 
             Q 40 180 30 120 
             Q 20 60 80 50 
             Q 140 40 150 100 
             Q 160 160 100 170
             Q 60 175 50 130
             Q 40 85 90 75"
          stroke="#14b8a6"
          strokeWidth="4"
          strokeLinecap="round"
          fill="none"
        />
      </svg>

      {/* Center Bottom Koru */}
      <svg
        className="absolute bottom-20 left-1/3 w-28 h-28 opacity-[0.05]"
        viewBox="0 0 200 200"
        fill="none"
      >
        <path
          d="M 100 20 
             Q 160 20 170 80 
             Q 180 140 120 150 
             Q 60 160 50 100 
             Q 40 40 100 30"
          stroke="#0ea5e9"
          strokeWidth="4"
          strokeLinecap="round"
          fill="none"
        />
      </svg>
    </div>
  );
};

export default KoruWatermark;
